

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // facetForm.querySelector('.matat-filters__close').addEventListener('click', ()=> {
    //   facetForm.querySelector('.filter-opener').dispatchEvent(new Event('click'));
    // });
    this.shortbyjs();
    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    setTimeout(() => {
      if (typeof initCardVariants === 'function') initCardVariants();
    }, 100);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // Price filter bar code 
    document
      .querySelectorAll('collection-filter-price')
      .forEach(el => el._setRangeStyles());
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  shortbyjs(){
    const element = document.getElementById('SortBy');
    const choices = new Choices(element, {
      searchEnabled: false,
      itemSelectText: '',
      allowHTML: true
    });
    document.querySelector('#SortBy').addEventListener('change', function(e){
      const currentURL = window.location.href;
      const url = new URL(currentURL);
      const searchParams = url.searchParams;
      let new_search = '';
      searchParams.forEach((value, key) => {
          if (key === 'sort_by') {
              new_search += `&${key}=${document.querySelector('#SortBy').value}`;
          } else {
              new_search += `&${key}=${value}`;
          }
      });
      new_search = new_search.startsWith('&') ? new_search.substring(1) : new_search;
      if(new_search == ""){
        new_search=`&sort_by=${document.querySelector('#SortBy').value}`;
      }
      console.log(new_search)
      FacetFiltersForm.renderPage(new_search);
    });
    document.querySelector('#FacetFiltersForm').classList.add('loaded');
    document.querySelector('#ProductGridContainer').classList.add('loaded');
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class CollectionFilterPrice extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            inputMin: '[data-element="input-min"]',
            inputMax: '[data-element="input-max"]'
        };
    }

    connectedCallback() {
        this.$inputMin = this.querySelector(this.elements.inputMin);
        this.$inputMax = this.querySelector(this.elements.inputMax);
        this.$valueMin = this.querySelector('.collection-filter-price-values-min');
        this.$valueMax = this.querySelector('.collection-filter-price-values-max');
        // Currency symbol is whatever surrounds the number in the server-rendered label
        this.currencySymbol = (this.$valueMax?.textContent || '').replace(/[\d.,\s]/g, '');

        if (this.$inputMin && this.$inputMax) {
            this._initSlider();
            this._setRangeStyles();
        }
    }

    _initSlider() {
        this.$inputMin.addEventListener('change', this._sliderChangeHandler.bind(this));
        this.$inputMin.addEventListener('input', this._handleInput.bind(this));
        this.$inputMax.addEventListener('change', this._sliderChangeHandler.bind(this));
        this.$inputMax.addEventListener('input', this._handleInput.bind(this));
    }

    _sliderChangeHandler() {
        this.dispatchEvent(new CustomEvent('filter:change', { bubbles: true }));
    }

    _handleInput({ target }) {
        this._checkInputsIntersection(target);
        this._setRangeStyles();
         this._updatePriceLabels();
    }

    _formatValue(value) {
        return Number.isInteger(value) ? `${value}` : value.toFixed(2);
    }

    _updatePriceLabels() {
        if (this.$valueMin) this.$valueMin.textContent = `${this._formatValue(this.minValue)}${this.currencySymbol}`;
        if (this.$valueMax) this.$valueMax.textContent = `${this._formatValue(this.maxValue)}${this.currencySymbol}`;
    }
    
    _checkInputsIntersection(target) {
        if (target === this.$inputMin && this.minValue > this.maxValue) {
            this.$inputMin.value = this.maxValue;
        }
        if (target === this.$inputMax && this.maxValue < this.minValue) {
            this.$inputMax.value = this.minValue;
        }
    }

    // _setRangeStyles() {
    //     const rangeMin = this.minValue / this.rangePercent;
    //     const rangeMax = this.maxValue / this.rangePercent;
    //     this.style.setProperty('--range-min', `${rangeMin}%`);
    //     this.style.setProperty('--range-max', `${rangeMax}%`);
    // }
    
    // Price filter bar range feature
    _setRangeStyles() {
      if (!this.$inputMin || !this.$inputMax) return;

      const minPrice = Number(this.$inputMin.min);
      const maxPrice = Number(this.$inputMax.max);

      if (Number.isNaN(minPrice) || Number.isNaN(maxPrice)) return;

      const range = maxPrice - minPrice;
      if (range <= 0) return;

      const rangeMin = ((this.minValue - minPrice) / range) * 100;
      const rangeMax = ((this.maxValue - minPrice) / range) * 100;

      this.style.setProperty('--range-min', `${rangeMin}%`);
      this.style.setProperty('--range-max', `${rangeMax}%`);
    }

    // get rangePercent() {
    //     return parseFloat(this.getAttribute('range-percent')) || 1;
    // }

    get minValue() {
        return this.$inputMin?.valueAsNumber || 0;
    }

    get maxValue() {
        return this.$inputMax?.valueAsNumber || 0;
    }
}

customElements.define('collection-filter-price', CollectionFilterPrice);



class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
